export default {
    name: 'sidebar',
    props: {
        title: {
            type: String,
            default: 'Loading...'
        },
        backgroundColor: {
            type: String,
            default: 'black',
            validator: (value) => {
                let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black']
                return acceptedValues.indexOf(value) !== -1
            }
        },
        backgroundImage: {
            type: String,
            default: 'static/img/sidebar-5.jpg'
        },
        activeColor: {
            type: String,
            default: 'success',
            validator: (value) => {
                let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
                return acceptedValues.indexOf(value) !== -1
            }
        },
        logo: {
            type: String,
            default: '/images/icons/favicon.ico'
        },
        sidebarLinks: {
            type: Array,
            default: () => []
        },
        autoClose: {
            type: Boolean,
            default: true
        }
    },
    provide() {
        return {
            autoClose: this.autoClose
        }
    },
    computed: {
        sidebarStyle() {
            return ''
            //{
            //    backgroundImage: `url(${this.backgroundImage})`
            //    
            //}
        }
    },
    methods: {
        async initScrollBarAsync() {
            await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
            const PerfectScroll = await import('perfect-scrollbar')
            PerfectScroll.initialize(this.$refs.sidebarScrollArea)
        }
    },
    mounted() {
        //this.initScrollBarAsync()
    },
    beforeDestroy() {
        if (this.$sidebar.showSidebar) {
            this.$sidebar.showSidebar = false
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/theme/SidebarPlugin/SideBar.js